import { useContext, useMemo } from "react";
import { RpcClientContext } from "../../contexts/rpc";
import type { VerifyAddress } from "./use-verify-address";

/** Verifies through the portal's RPC client, when the portal provides one. */
export function useRpcVerifyAddress(): VerifyAddress | undefined {
  const client = useContext(RpcClientContext);
  return useMemo(
    () => (client ? (input) => client.verifyAddress(input) : undefined),
    [client],
  );
}
